export default "__VITE_ASSET__DfZtFqTn__"